module.exports = __webpack_public_path__ + "img/NukedTV-Web_44.e859e83b.png";